import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import ColumnIconProps from './ColumnIconProps.interface';
import './column-icon.scss';

const ColumnIcon = ({
  id,
  icon,
  iconSize = 20,
  iconPlacement = 'left',
  value = null,
  align = 'left',
}: ColumnIconProps): JSX.Element => {
  Logging.Debug('Column Icon');

  return (
    <>
      <div key={id} className={`columnIcon columnIconAlign${align}`}>
        {
          icon && (iconPlacement === 'left')
          && (
            <VtxIcon type={icon} fontSize={iconSize} className="columnIconLeftIcon" />
          )
        }
        {
          value && (
            value
          )
        }
        {
          icon && (iconPlacement === 'right')
          && (
            <VtxIcon type={icon} fontSize={iconSize} className="columnIconRightIcon" />
          )
        }
      </div>
    </>
  );
};

export default ColumnIcon;
